export default function identifyMarkdownLinks(text) {
  // Pattern for inline links
  const inlineLinkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;
  // Pattern for reference links
  const referenceLinkPattern = /\[([^\]]+)\]\[([^\]]+)\]/g;
  // Pattern for reference definitions
  const referenceDefinitionPattern = /^\s*\[([^\]]+)\]:\s*(.+)$/gm;
  // Pattern for inline images
  const inlineImagePattern = /!\[([^\]]*)\]\(([^)]+)\)/g;

  let matches;
  let links = [];

  // Find inline links
  while ((matches = inlineLinkPattern.exec(text)) !== null) {
    links.push({ text: matches[1], url: matches[2], type: "inline" });
  }

  // Find reference link definitions
  let references = {};
  while ((matches = referenceDefinitionPattern.exec(text)) !== null) {
    references[matches[1]] = matches[2];
  }

  // Find reference links and resolve them using the reference definitions
  while ((matches = referenceLinkPattern.exec(text)) !== null) {
    if (references[matches[2]]) {
      links.push({
        text: matches[1],
        url: references[matches[2]],
        type: "reference",
      });
    }
  }

  // Find inline images
  while ((matches = inlineImagePattern.exec(text)) !== null) {
    links.push({ altText: matches[1], url: matches[2], type: "image" });
  }

  return links;
}
